export function Invoice(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        width: 'fit-content',
        display: 'flex',
        margin: 0,
        ...props.style,
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.93333 0C3.56514 0 3.26667 0.298477 3.26667 0.666667V12.0667C3.26667 12.4349 3.56514 12.7333 3.93333 12.7333H10.5333C10.9015 12.7333 11.2 12.4349 11.2 12.0667V3.13333L8.06667 0H3.93333Z"
          fill="currentColor"
        />

        <path
          d="M8.06667 0V2.66667C8.06667 3.03486 8.36514 3.33333 8.73333 3.33333H11.2"
          fill="white"
        />

        <rect
          x="4.66667"
          y="5.2"
          width="5.13333"
          height="0.8"
          rx="0.4"
          fill="white"
        />
        <rect
          x="4.66667"
          y="7.06667"
          width="5.13333"
          height="0.8"
          rx="0.4"
          fill="white"
        />
        <rect
          x="4.66667"
          y="8.93333"
          width="3.06667"
          height="0.8"
          rx="0.4"
          fill="white"
        />
        <rect
          x="4.66667"
          y="10.9333"
          width="5.13333"
          height="0.9"
          rx="0.45"
          fill="white"
        />
      </svg>
    </div>
  );
}
